export default "__VITE_ASSET__DDoTFLJh__"